module.exports = __webpack_public_path__ + "static/media/keks_logo.5dfecc06.png";